import React from "react";

import Header from "../../components/header/index";
import Footer from "../../components/footer";
import BookingContent from "./content/mainBookingContent";
import InnerHeader from "../../components/comment/innerHeader/innerHeader";

const index = () => {
  return (
    <>
      <section>
        <div className="main ">
          <Header />
          <InnerHeader title="My Booking" />
          <BookingContent />
          <Footer />
        </div>
      </section>
    </>
  );
};

export default index;
